var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolsSlsSolid({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 400,
    height: 30,
    viewBox: "0, 0, 400,30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "svgg"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path0",
    d: "M0.000 15.000 L 0.000 30.000 200.000 30.000 L 400.000 30.000 400.000 15.000 L 400.000 0.000 200.000 0.000 L 0.000 0.000 0.000 15.000 M389.429 6.364 C 389.710 6.518,390.045 6.770,390.172 6.923 C 390.298 7.075,390.790 7.448,391.264 7.752 C 394.347 9.724,395.431 14.535,393.602 18.127 C 393.115 19.082,390.768 21.405,389.940 21.751 C 389.150 22.081,9.233 22.136,8.614 21.806 C 7.905 21.427,6.026 19.618,5.724 19.021 C 5.555 18.689,5.207 18.111,4.951 17.737 C 3.622 15.799,3.709 12.318,5.137 10.348 C 5.428 9.946,5.667 9.521,5.667 9.404 C 5.667 9.071,6.487 8.181,7.062 7.892 C 7.349 7.748,7.860 7.365,8.197 7.042 C 8.569 6.686,9.127 6.369,9.614 6.238 C 11.016 5.861,388.739 5.986,389.429 6.364 ",
    stroke: "none",
    fill: "#fcfcfc",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1",
    d: "M9.614 6.238 C 9.127 6.369,8.569 6.686,8.197 7.042 C 7.860 7.365,7.349 7.748,7.062 7.892 C 6.487 8.181,5.667 9.071,5.667 9.404 C 5.667 9.521,5.428 9.946,5.137 10.348 C 3.709 12.318,3.622 15.799,4.951 17.737 C 5.207 18.111,5.555 18.689,5.724 19.021 C 6.026 19.618,7.905 21.427,8.614 21.806 C 9.233 22.136,389.150 22.081,389.940 21.751 C 390.768 21.405,393.115 19.082,393.602 18.127 C 395.431 14.535,394.347 9.724,391.264 7.752 C 390.790 7.448,390.298 7.075,390.172 6.923 C 390.045 6.770,389.710 6.518,389.429 6.364 C 388.739 5.986,11.016 5.861,9.614 6.238 ",
    stroke: "none",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolsSlsSolid);
export default __webpack_public_path__ + "static/media/symbols-sls-solid.0cea058affeed1c98ca500aebd0aee0e.svg";
export { ForwardRef as ReactComponent };